const mobileAppNoticeMessage = [
  "We’ve stopped support for our mobile app as we shift our focus toward new opportunities and what’s next for us.",
  "We’re incredibly grateful to all of our customers and supplier partners who have supported us along the way.",
  "Stay tuned — we’re excited to share what we’re working on next.",
];

let mobileAppNoticeElement = null;

function ensureMobileAppNotice() {
  if (mobileAppNoticeElement) return mobileAppNoticeElement;

  const notice = document.createElement("div");
  notice.id = "mobile-app-notice";
  notice.className = "mobile-app-notice";
  notice.setAttribute("aria-hidden", "true");
  notice.innerHTML = `
    <div class="mobile-app-notice__backdrop" data-mobile-app-notice-close></div>
    <div class="mobile-app-notice__dialog" role="dialog" aria-modal="true" aria-labelledby="mobile-app-notice-title">
      <button type="button" class="mobile-app-notice__close" aria-label="Close" data-mobile-app-notice-close>&times;</button>
      <h2 id="mobile-app-notice-title" class="mobile-app-notice__title">40hammocks Update</h2>
      <div class="mobile-app-notice__message">
        ${mobileAppNoticeMessage.map((paragraph) => `<p>${paragraph}</p>`).join("")}
      </div>
    </div>
  `;
  document.body.appendChild(notice);
  mobileAppNoticeElement = notice;

  notice.querySelectorAll("[data-mobile-app-notice-close]").forEach((button) => {
    button.addEventListener("click", closeMobileAppNotice);
  });

  return notice;
}

function openMobileAppNotice() {
  const notice = ensureMobileAppNotice();
  const closeButton = notice.querySelector(".mobile-app-notice__close");

  notice.classList.add("is-visible");
  notice.setAttribute("aria-hidden", "false");
  document.body.classList.add("mobile-app-notice-open");
  closeButton?.focus();
}

function closeMobileAppNotice() {
  if (!mobileAppNoticeElement) return;

  mobileAppNoticeElement.classList.remove("is-visible");
  mobileAppNoticeElement.setAttribute("aria-hidden", "true");
  document.body.classList.remove("mobile-app-notice-open");
}

document.addEventListener(
  "click",
  function (event) {
    const target = event.target instanceof Element ? event.target : event.target.parentElement;
    const trigger = target?.closest(
      '.mobile-app-notice-trigger, [data-mobile-app-notice-trigger="true"], a[href="#mobile-app-notice"]'
    );

    if (!trigger) return;

    event.preventDefault();
    event.stopPropagation();
    openMobileAppNotice();
  },
  true
);

document.addEventListener("keydown", function (event) {
  if (event.key === "Escape" && mobileAppNoticeElement?.classList.contains("is-visible")) {
    closeMobileAppNotice();
  }
});
